import { Component, ViewChild, ElementRef, Input } from '@angular/core';



declare const am4charts: any, am4core: any, am4themes_animated: any;


@Component({
    selector: 'arm-chart-pie',
    templateUrl: './arm-pie-chart.html',
    styleUrls: ['./arm-pie-chart.css']
})



export class ArmPiechartComponent {

    chart: any[];
    am4core: any;
    @Input() elemId: any = 'arm-chart-canvas-' + Math.random();

    @Input() _data: any = [
        // {
        //     labels: "Completed",
        //     data:0
        // },
        // {
        //     labels: "Pending",
        //     data: 0
        // },
        // {
        //     labels: "Intransit",
        //     data: 0
        // },
        // {
        //     labels: "Escort",
        //     data: 0,
        //     "color": am4core.color("#FBB13C")
        // },

    ]

    @Input() _colors = [ 
    
    ];

    ngOnInit() {
        setTimeout(() => {
            this.initChart();
        }, 500);

    }

    initChart() {
        am4core.useTheme(am4themes_animated);


        const chart = am4core.create(this.elemId, am4charts.PieChart3D);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.data = this._data;

        chart.innerRadius = am4core.percent(40);
        // chart.depth = 120;
        chart.depth = 10;
        chart.responsive.enabled = true;

        chart.legend = new am4charts.Legend();
        // chart.legend.position = "right";
        chart.legend.position = "bottom";
        // chart.colors.list = this._colors;
        const series = chart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "data";
        series.dataFields.depthValue = "data";
        series.dataFields.category = "labels";
        series.slices.template.cornerRadius = 5;


        var colorSet = new am4core.ColorSet();
        colorSet.list = this._colors.map(function (color) {
            return new am4core.color(color);
        });
        series.colors = colorSet;


        // series.colors.step = 3;
    }

}